import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Card, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';

//Context
import { useAuth } from '../../../context/auth';

//Components
import TextField from '../../../components/TextField';

//Helpers
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
import mascaras from '../../../helpers/mascaras';
import { showMessage } from '../../../helpers/message';

//Api
import requerente_api from '../../../api/requerente_api';

function initialStateCadastro() {
    return {
        nome: "",
        documentoPessoal: "",
        email: "",
        confirmarEmail: "",
        dataCadastro: moment().format()
    }
}
export default function Cadastro() {
    const navigate = useNavigate();

    const { setLoading } = useAuth();

    //Campos obrigatorios para cadastro do requerente
    const campos = [
        objCampo({ name: "documentoPessoal", required: true, cpfcnpj: true }),
        objCampo({ name: "nome", required: true }),
        objCampo({ name: "email", required: true, email: true }),
        objCampo({ name: "confirmarEmail", required: true, email: true }),
    ]

    //Estado de controle dos erros nos campos
    const [errors, setErrors] = useState({});

    //Estado de controle dos dados do cadastro
    const [cadastro, setCadastro] = useState(initialStateCadastro);

    //onChange para os campos do cadastro
    const onChange = (e) => {
        const { name, value } = e.target;
        const _cadastro = {
            ...cadastro,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_cadastro, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setCadastro(_cadastro);
    }

    //onSubmit do cadastro
    const onSubmit = () => {
        //Validando os campos obrigatorios
        const _errors = validarCampos(cadastro, campos);
        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return

        if (cadastro.email !== cadastro.confirmarEmail) {
            setErrors({ email: { message: "Os e-mails não são iguais" } });
            return;
        }
        const _cadastro = { ...cadastro }
        delete _cadastro.confirmarEmail;

        //Enviando os dados
        setLoading(true);
        requerente_api.post(_cadastro).then(response => {
            showMessage("Sucesso", "Cadastro realizado com sucesso.", "success", null);
            navigate(-1);
        }).catch(e => {
            showMessage("Erro", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    return (
        <div className='mainContainerLogin'>
            <Card className='mt-5 w-100' style={{ border: "none", padding: "1rem" }}>
                <h4 className='text-secondary d-flex'>
                    <span onClick={() => navigate(-1)} role='button' className='me-2 d-flex align-items-center justify-content-start' >
                        <FontAwesomeIcon icon={faAngleLeft} />
                    </span>
                    Dados primários
                </h4>
                <Row className='mt-3'>
                    <Col md="6" lg="6">
                        <TextField maxLength={18} mask={mascaras.cpfcnpjMask} label={"* CPF/CNPJ"} onChange={onChange} value={cadastro.documentoPessoal} name={"documentoPessoal"} invalid={errors.documentoPessoal} />
                        <PrintValidate errors={errors} field={"documentoPessoal"} />
                    </Col>
                    <Col md="6" lg="6">
                        <TextField maxLength={100} label={"* Nome/Razão social"} onChange={onChange} value={cadastro.nome} name={"nome"} invalid={errors.nome} />
                        <PrintValidate errors={errors} field={"nome"} />
                    </Col>
                    <Col md="6" lg="6">
                        <TextField maxLength={150} label={"* E-mail"} onChange={onChange} value={cadastro.email} name={"email"} invalid={errors.email} />
                        <PrintValidate errors={errors} field={"email"} />
                    </Col>
                    <Col md="6" lg="6">
                        <TextField maxLength={150} label={"* Confirmar E-mail"} onChange={onChange} value={cadastro.confirmarEmail} name={"confirmarEmail"} invalid={errors.confirmarEmail} />
                        <PrintValidate errors={errors} field={"confirmarEmail"} />
                    </Col>
                    <Col className='d-flex align-items-center justify-content-center' md="12" lg="12" >
                        <Button color='success' className='px-5 mt-3' onClick={onSubmit}>Cadastrar</Button>
                    </Col>
                </Row>
            </Card>
        </div>
    )
}